
(function () {
  const sliders = new WeakMap();

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) initSlider(entry.target);
    });
  }, { rootMargin: '200px' });

  function initSlider(el) {
    if (sliders.has(el)) return;

    const wrapper = el.querySelector('.card-product-slider-wrapper');
    const slides = Array.from(el.querySelectorAll('.card-product-media-slide'));
    const dotsContainer = el.querySelector('.slider-dots');
    const total = slides.length;

    if (total <= 1) {
      el.querySelector('.slider-btn--prev-d5').style.display = 'none';
      el.querySelector('.slider-btn--next-d5').style.display = 'none';
      return;
    }

    // Clone only the LAST slide and prepend it
    const cloneBefore = slides[total - 1].cloneNode(true);
    cloneBefore.setAttribute('data-clone', '');
    wrapper.insertBefore(cloneBefore, wrapper.firstChild);

    // Clone only the FIRST slide and append it
    const cloneAfter = slides[0].cloneNode(true);
    cloneAfter.setAttribute('data-clone', '');
    wrapper.appendChild(cloneAfter);

    // Offset is now always 1 (one clone before real slides)
    const offset = 1;

    // Grab all slides including clones, for active class management
    const allSlides = Array.from(wrapper.querySelectorAll('.card-product-media-slide'));

    const dots = Array.from({ length: total }, (_, i) => {
      const d = document.createElement('span');
      d.className = 'slider-dot' + (i === 0 ? ' active' : '');
      const fill = document.createElement('span');
      fill.className = 'slider-dot-fill';
      d.appendChild(fill);
      dotsContainer.appendChild(d);
      return d;
    });

    let current = 0;
    let isHovered = false;
    let scrollTimer;

    function updateDots(index) {
      dots.forEach((d, i) => d.classList.toggle('active', i === index));
      allSlides.forEach((s, i) => s.classList.toggle('active', i === index + offset));
    }

    function scrollToIndex(index, behavior = 'smooth') {
      const slideWidth = wrapper.offsetWidth;
      wrapper.scrollTo({ left: slideWidth * (index + offset), behavior });
    }

    function jumpSilently(index) {
      wrapper.style.scrollBehavior = 'auto';
      wrapper.scrollLeft = wrapper.offsetWidth * (index + offset);
      wrapper.style.scrollBehavior = '';
    }

    jumpSilently(0);
    updateDots(0);
    sliders.set(el, true);

    function goTo(index) {
      current = ((index % total) + total) % total;
      scrollToIndex(current);
      updateDots(current);
      hoverp = wrapper.closest('.product-card')
      const videop = hoverp.querySelector('.product-hover-video');
      hoverp.classList.remove('hover');
      videop.pause();
      videop.currentTime = 0;
    }

    el.querySelector('.slider-btn--prev-d5').addEventListener('click', (e) => { e.preventDefault(); goTo(current - 1); });
    el.querySelector('.slider-btn--next-d5').addEventListener('click', (e) => { e.preventDefault(); goTo(current + 1); });

    wrapper.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        if (isHovered) return;
        const slideWidth = wrapper.offsetWidth;
        const rawIndex = Math.round(wrapper.scrollLeft / slideWidth);

        // Hit the before-clone (rawIndex = 0) → jump to last real slide
        if (rawIndex === 0) {
          jumpSilently(total - 1);
          current = total - 1;
        // Hit the after-clone (rawIndex = total + 1) → jump to first real slide
        } else if (rawIndex === total + 1) {
          jumpSilently(0);
          current = 0;
        } else {
          current = rawIndex - offset;
        }

        updateDots(current);
      }, 50);
    }, { passive: true });

    //  el.addEventListener('mouseenter', () => {
    //   if (total < 2) return;
    //   isHovered = true;
    //   current = 1;
    //   scrollToIndex(1);
    //   updateDots(1); 
    // }); 
    const hoverEl = el.closest('.product-card');
    const video = hoverEl.querySelector('.product-hover-video')
    hoverEl.addEventListener('mouseenter', () => {
      if (total < 2) return;
      isHovered = true;
      hoverEl.classList.add('hover')
      video.play().catch(() => {});
      });
    hoverEl.addEventListener('mouseleave', () => {
      setTimeout(() => {
      hoverEl.classList.remove('hover')
      video.pause();
      video.currentTime = 0;
      },200)
    });
  }

  document.querySelectorAll('[data-slider]').forEach(el => observer.observe(el));

  window.reinitSliders = function (container) {
    const root = (container instanceof Element) ? container : document.querySelector(container);
    if (!root) return;
    root.querySelectorAll('[data-slider]').forEach(el => observer.observe(el));
  };


  document.addEventListener('DOMContentLoaded', () => {
  const videos = document.querySelectorAll('.reveal-video');

  const playMedia = (el) => {
    // YouTube iframe
    if (el.tagName === 'IFRAME') {
      el.contentWindow?.postMessage(
        JSON.stringify({
          event: 'command',
          func: 'playVideo',
          args: []
        }),
        '*'
      );
    }

    // HTML5 video
    if (el.tagName === 'VIDEO') {
      const promise = el.play();
      if (promise !== undefined) {
        promise.catch(() => {});
      }
    }
  };

  const pauseMedia = (el) => {
    if (el.tagName === 'IFRAME') {
      el.contentWindow?.postMessage(
        JSON.stringify({
          event: 'command',
          func: 'pauseVideo',
          args: []
        }),
        '*'
      );
    }

    if (el.tagName === 'VIDEO') {
      el.pause();
    }
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const el = entry.target;

      setTimeout(() => {
        if (entry.isIntersecting) {
          playMedia(el);
        } else {
          pauseMedia(el);
        }
      }, 300);
    });
  }, { threshold: 0.5 });

  videos.forEach(v => observer.observe(v));
});
})();